import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence, useInView } from "framer-motion";
import { EASE } from "@/components/motion";

const WORDS = ["BUSCAR", "LLAMAR", "ESPERAR", "COORDINAR"];

export default function WordSwap() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-25% 0px" });
  const [index, setIndex] = useState(0);
  const done = index >= WORDS.length;

  useEffect(() => {
    if (!inView || done) return;
    const t = setTimeout(() => setIndex((i) => i + 1), 1250);
    return () => clearTimeout(t);
  }, [inView, index, done]);

  return (
    <div ref={ref} className="min-h-[9rem] md:min-h-[13rem] flex items-center" data-testid="word-swap">
      <AnimatePresence mode="wait">
        {!done ? (
          <motion.span
            key={WORDS[index]}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -40, filter: "blur(6px)" }}
            transition={{ duration: 0.45, ease: EASE }}
            className="relative inline-block font-oswald font-600 uppercase text-6xl md:text-8xl lg:text-9xl tracking-tight text-steel"
          >
            {WORDS[index]}
            <motion.span
              className="absolute left-0 top-1/2 h-[3px] w-full bg-glow/80 origin-left"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ delay: 0.45, duration: 0.4, ease: "easeInOut" }}
            />
          </motion.span>
        ) : (
          <motion.span
            key="final"
            initial={{ opacity: 0, scale: 0.94, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE }}
            className="font-oswald font-700 uppercase text-6xl md:text-8xl lg:text-9xl tracking-tight text-metal"
          >
            APREA GESTIONA.
          </motion.span>
        )}
      </AnimatePresence>
    </div>
  );
}
